import React, { useReducer } from 'react';
import { UIHeading1 } from '@cian/ui-kit';

import { BreadCrumbsContainer } from '../BreadCrumbs';
import { AddBlogPostForm } from '../../components/AddPostForm';
import { Title as TitleField } from '../../components/AddPostFormFields';
import { blogPostFormReducer, blogPostInitialState, useTitleField } from '../../utils/postForm';

/**
 * Контейнер формы добавления/редактирования поста блога
 */
export const AddBlogPostFormContainer = () => {
  const [state, dispatch] = useReducer(blogPostFormReducer, blogPostInitialState);
  const titleProps = useTitleField(state, dispatch);

  return (
    <>
      <BreadCrumbsContainer />
      <AddBlogPostForm heading={<UIHeading1>Новая запись</UIHeading1>} titleField={<TitleField {...titleProps} />} />
    </>
  );
};
